import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import toJS from '../../../lib/hocs/toJS';
import Folder from './Folder';
import Page from './Page';

const styles = (theme) => ({
  nav: {
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  addPageButton: {
    height: 48,
    color: theme.palette.primary.contrastText,
    textDecoration: 'underline',
    width: '100%',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
});

class Navbar extends Component {
  renderAddPageButton() {
    const { isEditingOrganization, classes, navbarItems } = this.props;
    const editLabel =
      navbarItems.length === 0 ? '+ Add Pages/Folders' : 'Edit Pages/Folders';
    return (
      isEditingOrganization && (
        <Button className={classes.addPageButton} href="/admin/pages">
          {editLabel}
        </Button>
      )
    );
  }

  renderFolderOrPage(item) {
    const { isEditingOrganization } = this.props;
    return item.type === 'FolderPage' ? (
      <Folder
        folder={item}
        isEditingOrganization={isEditingOrganization}
        key={item.id}
      />
    ) : (
      item.isActive && <Page page={item} key={item.id} />
    );
  }

  render() {
    const { navbarItems, classes, isEditingOrganization } = this.props;
    return (
      <nav className={classes.nav}>
        {navbarItems.map((item) => this.renderFolderOrPage(item))}
        {isEditingOrganization && this.renderAddPageButton()}
      </nav>
    );
  }
}

Navbar.propTypes = {
  classes: PropTypes.object.isRequired,
  isEditingOrganization: PropTypes.bool,
  navbarItems: PropTypes.array.isRequired,
};
Navbar.defaultProps = {
  isEditingOrganization: false,
};

export default toJS(withStyles(styles)(Navbar));
